landingHandler = {
    $collectionSlider: $('.collection-slider-container'),
    
    init: function() {
        var self = this;

        self.$collectionSlider.each(function() {
            var $slider = $(this)
            //var isEven = $(this).hasClass('even-slider');

            var cellAlign = 'left';
            // if (isEven) {
            //     cellAlign = 'left';
            // }

            var slider = $slider.flickity({
                cellSelector: '.collection-slider-cell',
                cellAlign: cellAlign,
                //autoPlay: 2500,
                pauseAutoPlayOnHover: false,
                draggable: true,
                contain: true,
                pageDots: false,
                wrapAround: true,
                prevNextButtons: true,
                accessibility: false,
                //rightToLeft: isEven,
                on: {
                    ready: function() {
                        $slider.find('[aria-hidden]').removeAttr('aria-hidden')
                    },
                },
            });

            // Focus event
            $slider.on('focus', '.coll-link', function(e) {
                var $cell = $(this).closest('.collection-slider-cell')
                var index = $cell.data('index')
                $slider.flickity('select', index)
            });
        });
    }
}